import { Heading, Layout, Paragraph } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../hooks/useAuth";

export const SecondAuthHeader = () => {
  const { t } = useTranslation("secondauthfactor");
  const { authResponse } = useAuth();
  return (
    <Layout.Item className="u-text-center">
      <Heading level={1}>{t("header")}</Heading>
      <Paragraph>{t("subheader.header1")}</Paragraph>
      <Paragraph>
        {t("subheader.header2", {
          number: authResponse?.mobilePhoneNumberMask,
        })}
      </Paragraph>
    </Layout.Item>
  );
};

export default SecondAuthHeader;
